import React from "react";
import Header from "../MerchandiseStore/Header/Header";
import Footer from "../../components/partials/FooterComponent";
import { connect } from "react-redux";

const ShippingPolicy = (props) => {
  return (
    <>
      <Header totalItems={props.totalItems} />
      <div className="container mb-5">
        <div className="row">
          <div className="col-12">
            <h1 className="text-center font-weight-bold mt-4">Shipping Policy</h1>
            <br />
            <div className="">
              {/* <p>
                All prices on the website are inclusive of courier/shipping charges.<br />
                Orders placed should be received within 7-14 business days. Orders placed on Sundays or public holidays will be handled on the first working day after.<br />
                Shipping can be delayed due to the current COVID 19 situation or situations beyond our control. <br />
                Delivery services are available only in India.
              </p> */}
              <ul className="pl-4">
                <li>
                All prices on the website are inclusive of courier/shipping charges.
                </li>
                <li>
                Orders placed should be received within 7-14 business days. Orders placed on Sundays or public holidays will be handled on the first working day after.
                </li>
                <li>
                Shipping can be delayed due to the current COVID 19 situation or situations beyond our control.
                </li>
                <li>
                Delivery services are available only in India.
                </li>
              </ul>
              
            </div>  
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    totalItems: state.cart.totalItems,
  };
};

export default connect(mapStateToProps)(ShippingPolicy);
